import { AppCommonFilters } from "@components";
import React, {useEffect} from "react";
import { BACKEND_APIS, COMMON_FILTERS_COMPONENTS, SERVICES_TYPE } from "@constants";
import {
    areCommonFiltersValid,
    rentalDates,
    siteMarket,
    sites,
    tiers,
    isOfficeGroup,
    officeGroup,
    isSiteGroup,
    siteGroup,
} from "@signals";
import {useValidatorSeeker} from "@ui-seeker/app";
import {europcarPricingEnvFilters } from "../@signals";
import {europcarPricingEnvironmentSchema} from "./schema";
import {removeDuplicatedDates} from "../../../../../@utils";
import {dateToString} from "../../../../ReportsAlerts/Reports/@utils";

export default function EuropcarPricingEnvironmentFilters() {

    const { errors, isValid } = useValidatorSeeker(europcarPricingEnvFilters.value, europcarPricingEnvironmentSchema)

    useEffect(() => {
        areCommonFiltersValid.value = isValid
    }, [isValid])

    const onAjaxCommon = options => options.map(option => ({
        label: `${option.label}`,
        value: `${option.value}`,
    }))

    const showMarketOrSite = siteMarket.value
        ? {
            name: COMMON_FILTERS_COMPONENTS.MARKETS,
            grid: { xs: 3 },
            multiple: true,
        }
        : isSiteGroup.value
        ? {
            name: COMMON_FILTERS_COMPONENTS.SITE_GROUP,
            label: 'Site Group',
            multiple: true,
            grid: { xs: 3 },
            filters: {
                service_type: SERVICES_TYPE.BI,
                siteGroupID: siteGroup.value,
            },
            error: errors?.siteGroupID,
        }
        : {
            name: COMMON_FILTERS_COMPONENTS.SITE,
            urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/site`,
            grid: { xs: 3 },
            filters: {
                service_type: SERVICES_TYPE.BI
            }
        }


    return <AppCommonFilters
        headerComponents={[
            {
                name: COMMON_FILTERS_COMPONENTS.DAILY_PRICE_TOGGLE,
                grid: { xs: 1.5 },
            }, {
                name: COMMON_FILTERS_COMPONENTS.IS_OFFICE_GROUP,
                grid: { xs: 1.5 },
            }, {
                name: COMMON_FILTERS_COMPONENTS.SITE_MARKET_TOGGLE,
                grid: { xs: 1.5 },
            }, !siteMarket.value && {
                name: COMMON_FILTERS_COMPONENTS.IS_SITE_GROUP,
                grid: { xs: 1.5 },
            }
        ]}
        components={[
            {
                name: COMMON_FILTERS_COMPONENTS.BOOKING_WEEKS,
                grid: { xs: 2 },
                error: errors.bookingWeek,
            }, {
                name: COMMON_FILTERS_COMPONENTS.DATES,
                error: errors.pickupDate,
                onChange: date => {
                    rentalDates.value = removeDuplicatedDates(dateToString(date))
                },
            }, !isOfficeGroup.value && {
                name: COMMON_FILTERS_COMPONENTS.OFFICE_PICKUP,
                error: errors.officePickupID,
                multiple: true,
                grid: { xs: 3 },
                filters: {
                    service_type: SERVICES_TYPE.BI
                }
            }, isOfficeGroup.value && {
                name: COMMON_FILTERS_COMPONENTS.OFFICE_GROUP,
                label: 'Pickup office Group',
                multiple: true,
                grid: { xs: 3 },
                filters: {
                    service_type: SERVICES_TYPE.BI,
                    officeGroupID: officeGroup.value,
                },
                error: errors?.officeGroupID,
            },
            showMarketOrSite,
            {
                name: COMMON_FILTERS_COMPONENTS.TIERS,
                grid: { xs: 2 },
                filters: {
                    siteID: sites.value,
                    selected: tiers.value,
                    service_type: SERVICES_TYPE.BI,
                },
            }, {
                name: COMMON_FILTERS_COMPONENTS.PROVIDERS,
                error: errors.providerID,
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/provider`,
                grid: { xs: 3 },
                filters: {
                    service_type: SERVICES_TYPE.BI
                }
            }, {
                name: COMMON_FILTERS_COMPONENTS.CATEGORIES,
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/category`,
                grid: { xs: 3 },
                filters: {
                    service_type: SERVICES_TYPE.BI
                }
            }, {
                name: COMMON_FILTERS_COMPONENTS.RENTAL_LENGTH,
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/lor`,
                error: errors.lor,
                onAjax: onAjaxCommon,
                disableClearable: false,
                grid: { xs: 1 },
                filters: {
                    service_type: SERVICES_TYPE.BI
                }
            }, {
                name: COMMON_FILTERS_COMPONENTS.ACRISS,
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/acriss`,
                grid: { xs: 3 },
                filters: {
                    service_type: SERVICES_TYPE.BI
                }
            }, {
                name: COMMON_FILTERS_COMPONENTS.TRANSMISSION,
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/transmission`,
                grid: { xs: 2 },
                filters: {
                    service_type: SERVICES_TYPE.BI
                }
            }, {
                name: COMMON_FILTERS_COMPONENTS.CURRENCY,
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/currencies`,
                grid: { xs: 2 },
                filters: {
                    service_type: SERVICES_TYPE.BI,
                    siteID: sites.value
                },
                error: errors?.currency
            }
        ]}
    />
}